import React from "react";
import { useNavigate } from "react-router-dom";
import { Vg2Shell } from "./Vg2Shell";
import { startJourney, getStoredJourneyId, getJourney } from "@/lib/vg2Journey";

export default function CapisciEntry() {
  const navigate = useNavigate();
  const [busy, setBusy] = React.useState(false);
  const [error, setError] = React.useState(null);

  // On mount: if a stored journey_id is still valid and not completed,
  // silently offer resume by pushing straight into the flow.
  React.useEffect(() => {
    const jid = getStoredJourneyId();
    if (!jid) return;
    (async () => {
      try {
        const js = await getJourney(jid);
        if (!js.completed) navigate(`/vg2/${jid}`, { replace: true });
      } catch {
        // stale id — ignore silently
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onStart = async () => {
    setBusy(true); setError(null);
    try {
      const js = await startJourney();
      navigate(`/vg2/${js.journey_id}`);
    } catch (e) {
      setError("Non riesco ad avviare la sessione. Verifica la connessione e riprova.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Vg2Shell>
      <div data-testid="capisci-entry" className="pt-16 md:pt-20 pb-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-7">
        <p className="text-vg2-muted text-sm uppercase tracking-[0.18em] mb-8">
          ValutaGenio · Capisci · Valuta · Decidi · Agisci
        </p>
        <h1 className="text-4xl md:text-5xl font-display font-semibold leading-[1.15] tracking-tight mb-6">
          Un immobile è una leva
          <br />per i tuoi obiettivi.
        </h1>
        <p className="text-vg2-muted text-lg md:text-xl leading-relaxed max-w-[540px] mb-14">
          Capisci il tuo caso, misura quanto vale, decidi la strada giusta,
          agisci con evidenze.
        </p>

        <div className="border-t border-vg2-line pt-10">
          <p className="text-vg2-muted text-sm uppercase tracking-[0.18em] mb-4">
            Prima domanda
          </p>
          <h2 className="font-display font-semibold text-2xl md:text-3xl leading-snug mb-10">
            Cosa vuoi ottenere dal tuo immobile?
          </h2>
          <button
            data-testid="capisci-start-btn"
            onClick={onStart}
            disabled={busy}
            className="group inline-flex items-center gap-3 rounded-full bg-vg2-red text-white hover:bg-vg2-red-hover px-8 py-4 text-base font-semibold tracking-tight transition-colors disabled:opacity-50"
          >
            {busy ? "Sto preparando…" : "Inizia da qui"}
            <span aria-hidden className="translate-x-0 transition-transform group-hover:translate-x-1">→</span>
          </button>
          {error && (
            <p role="alert" data-testid="entry-error"
               className="mt-6 text-sm text-vg2-error">{error}</p>
          )}
          <p className="mt-10 text-xs text-vg2-muted leading-relaxed max-w-[480px]">
            Le informazioni che inserisci restano private. Sarai tu a decidere
            se e come utilizzarle o condividerle.
          </p>
        </div>
        </div>
        <aside className="md:col-span-5">
          <img
            src="/images/vg2/vg-capisci-inizio-percorso.webp"
            alt="Coppia di proprietari a casa, davanti al computer, con planimetria, chiavi e appunti sul tavolo."
            width={1086}
            height={1448}
            loading="eager"
            decoding="async"
            data-testid="capisci-entry-photo"
            className="w-full object-cover rounded-2xl shadow-[0_20px_50px_-25px_rgba(0,0,0,0.15)]"
          />
        </aside>
      </div>
    </Vg2Shell>
  );
}
